import React from "react";
import { Icon, Menu, Modal } from "semantic-ui-react";
import { AppIcon } from "./app-icon";
import { Link } from "gatsby";
import { topMenuContent } from "./top-menu-items";
import svg from "./screenpresso-logo.svg";
import { Flag } from "../flag";
import { setPreferredLocale } from "../i18link/redirect";

export const TopMenuMobile = ({ onClick, siteTitle, locale }) => (
  <Menu fixed="top" size="large" className="mobile only" borderless>
    <AppIcon siteTitle={siteTitle} locale={locale} />

    <Menu.Menu position="right">
      <Menu.Item onClick={onClick}>
        <Icon name="sidebar" /> Menu
      </Menu.Item>
    </Menu.Menu>
  </Menu>
);

export const ModalMenu = ({
  visible,
  onClose,
  siteTitle,
  siteMap,
  locale,
  locales,
}) => (
  <Modal
    size="fullscreen"
    basic
    open={visible}
    onClose={onClose}
    closeIcon={true}
    onClick={onClose}
    className="mobile-menu"
  >
    <Modal.Header>
      <Link
        className="mobile-menu-logo"
        to={`/${locale && locale !== "en" ? locale + "/" : ""}`}
      >
        <img src={svg} alt="Screenpresso logo" /> {siteTitle}
      </Link>
    </Modal.Header>
    <Modal.Content>
      <Menu secondary vertical>
        {topMenuContent(siteMap, locale).map((s, index) => (
          <Menu.Item as={Link} to={s.path} key={`mobile_menu_item_${index}`}>
            <h2>{s.text}</h2>
          </Menu.Item>
        ))}
      </Menu>
      <Menu secondary vertical>
        {locales &&
          locales.map((item, index) => (
            <Link
              to={item.path}
              key={`lang_selector_${index}`}
              onClick={() => setPreferredLocale(item.locale)}
            >
              <Flag size="large" locale={item.locale} title />
              &nbsp;
            </Link>
          ))}
      </Menu>
    </Modal.Content>
  </Modal>
);
